export const FETCH_SUCCESS = 'entities/FETCH_SUCCESS';
export const FETCH_ERROR = 'entities/FETCH_ERROR';
